import { useViewport } from 'contexts/viewport';
import moment from 'moment';
import { PageContext } from 'pages/InstructorFormativeJourney/PageProvider';
import { useContext } from 'react';
import { Button, Divider, Paper, Stack, styled, Text, ViewMore } from 'shell/components';
import { getRubricMaxPoints, getRubricTotalSuggestedPoints } from 'utils/helper';

const getDraftNumberText = (index) => {
    return String(index + 1);
};

const getUploadDateText = (submission) => {
    const timestamp = submission?.created_on;
    if (!timestamp) return '--';
    return moment(timestamp).format('MMMM D, YYYY h:mm A');
};

const getProficiencyLevelText = (submission) => {
    if (!submission) return '--';
    return `${getRubricTotalSuggestedPoints(submission.assignment_snapshot, submission)}/${getRubricMaxPoints(submission.assignment_snapshot.rubric.criteria)}`;
};

const getFeedbackInteractionsText = (submission) => {
    if (!submission) return '--';
    // TODO implement this
    return 0;
};

const getPerformanceText = (submission) => {
    return submission?.ai?.ai_performance_summary ?? '--';
};

const DraftCard = ({ index }) => {
    const { device } = useViewport();

    const { currentStudentSubmissions, onClickViewFormative, onClickViewSubmission } = useContext(PageContext);

    const currentStudentSubmission = currentStudentSubmissions[index];

    return (
        <Stack sx={{ width: device !== 'desktop' ? '100%' : '260px' }} spacing={5}>
            <CustomPaper sx={{ alignSelf: 'center', width: 'fit-content' }}>
                <Text weight={'medium'}>Draft {getDraftNumberText(index)}</Text>
            </CustomPaper>
            <CustomPaper>
                <Stack spacing={5}>
                    <Stack direction={'row'} justifyContent={'space-between'}>
                        <Text color={'light'}>Draft {getDraftNumberText(index)}</Text>
                        <Text color={'light'}>{getUploadDateText(currentStudentSubmission)}</Text>
                    </Stack>
                    <Button
                        disabled={!currentStudentSubmission}
                        variant={'secondary'}
                        onClick={() => onClickViewSubmission(currentStudentSubmission.id)}
                    >
                        View Feedback
                    </Button>
                </Stack>
            </CustomPaper>
            <CustomPaper>
                <Stack spacing={3}>
                    <Text weight={'medium'}>For Instructor Insights</Text>
                    <Stack alignItems={'flex-start'} direction={'row'} justifyContent={'space-between'}>
                        <Stack>
                            <Text weight={'medium'}>Proficiency Level</Text>
                            <Text weight={'medium'}>(Not shown to student)</Text>
                        </Stack>
                        <Text>{getProficiencyLevelText(currentStudentSubmission)}</Text>
                    </Stack>
                    <Stack direction={'row'} justifyContent={'space-between'}>
                        <Text weight={'medium'}>Feedback interactions</Text>
                        <Text>{getFeedbackInteractionsText(currentStudentSubmission)}</Text>
                    </Stack>
                    <Divider />
                    <Stack
                        direction={currentStudentSubmission ? 'column' : 'row'}
                        justifyContent={'space-between'}
                        spacing={1}
                    >
                        <Text weight={'medium'}>Student Performance</Text>
                        <ViewMore variant={'primary'}>{getPerformanceText(currentStudentSubmission)}</ViewMore>
                    </Stack>
                    <Divider />
                    <Button
                        sx={{ width: 'fit-content' }}
                        disabled={!currentStudentSubmission}
                        variant={'borderless'}
                        onClick={() => onClickViewFormative(currentStudentSubmission.id)}
                    >
                        View Parameters
                    </Button>
                </Stack>
            </CustomPaper>
        </Stack>
    );
};

const CustomPaper = styled(Paper)(({ theme }) => {
    return {
        padding: theme.spacing(3),
    };
});

export default DraftCard;
